import { render, staticRenderFns } from "./ConsultasOdontologicas.vue?vue&type=template&id=c7908ffa"
import script from "./ConsultasOdontologicas.vue?vue&type=script&lang=js"
export * from "./ConsultasOdontologicas.vue?vue&type=script&lang=js"
import style0 from "./ConsultasOdontologicas.vue?vue&type=style&index=0&id=c7908ffa&prod&lang=css"
import style1 from "./ConsultasOdontologicas.vue?vue&type=style&index=1&id=c7908ffa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports